import useCookie from "./useCookie";
import INTOUCH_API from "../services/Api";
import { useState } from "react";
import config from "../config";
import * as Sentry from "@sentry/react";
const CryptoJS = require("crypto-js");

export default function useAuth() {
  const { getCookie, setCookie } = useCookie();
  const [isLoading, setIsLoading] = useState(false);
  const token = getCookie("token");

  const setToken = (token) => {
    const inOneMonth = new Date(new Date().getTime() + 43800 * 60 * 1000);
    setCookie("token", token, {
      sameSite: "strict",
      expires: inOneMonth,
      secure: true,
    });
    if (window.isRNWebView) {
      postTokenToApp(token);
    }
  };

  const getToken = () => {
    return getCookie("token");
  };

  const postTokenToApp = (token) => {
    const encryptedTokenForApp = CryptoJS.AES.encrypt(
      token,
      config.tokenSecretPassphrase
    );
    window.postMessage(
      JSON.stringify({
        type: "AUTH_TOKEN",
        data: encryptedTokenForApp.toString(),
      }),
      "*"
    );
  };

  const checkAuth = async () => {
    setIsLoading(true);
    const authToken = getCookie("token");
    if (!authToken || authToken === "undefined") {
      setIsLoading(false);
      return false; // ✅ Возвращаем false, если не авторизован
    }
    
    let isAuthenticated = false;
    await INTOUCH_API.requestManager(
      "authorization",
      null,
      (response) => {
        setToken(response.data.token);
        isAuthenticated = true;
      },
      (error) => {
        console.error(error);
        Sentry.captureException(error, {
          tags: {
            feature: "authorization",
            component: "useAuth",
          },
          level: "warning",
        });
        isAuthenticated = false;
      }
    ).finally(() => {
      setIsLoading(false);
    });
    
    return isAuthenticated; // ✅ Возвращаем результат авторизации
  };

  return {
    token,
    setToken,
    checkAuth,
    isLoading,
    getToken,
  };
}
